import { store } from '@betacrew/jars-flux';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import SignUpDataService from '../../../../services/SignUpDataService';
import UserDataService from '../../../../services/UserDataService'
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import { GENERIC_ERROR_MESSAGE, PAGE_STATE } from '../../constants/constants';
import { componentKey, setFields, setIsEmailValid, setLoadingState, setResetForm, setSalesTaxAdminStatus, setUserInfo } from './GeneralSlice';
import { checkUserIsAuthenticated } from '../../authentication/AuthenticationSaga';
import { setIsUserAuthenticated, setSignedInUser } from '../../authentication/AuthenticationSlice';
import GeneralDataService from '../../../../services/GeneralDataService';
import { setIsTinUnmaskAllowed } from '../../dashboard/DashboardSlice';
import { getUpdatedSignedInUserProfile } from '../../dashboard/DashboardSaga';

export const { getGeneralSettings, updateMaskUnmaskOptions, updateGeneralInfo, updateScheduleDate, updateSupportMail, saveIsEmailOptOut, saveIsRecipientTinUnMask,saveIsFormsRoutingToUSPSMail,getSalesTaxExemptionStatus } = {
	getGeneralSettings: (payload) => {
		return {
			type: "GENERAL/GET_GENERAL_SETTINGS",
			payload: payload
		}
	},
	updateMaskUnmaskOptions: (payload) => {
		return {
			type: "GENERAL/UPDATE_MASK_UNMASK_OPTION",
			payload: payload
		}
	},
	updateGeneralInfo: (payload) => {
		return {
			type: "GENERAL/UPDATE_GENERAL_OPTION",
			payload: payload
		}
	},
	updateScheduleDate: (payload) => {
		return {
			type: "GENERAL/UPDATE_SCHEDULE_DATE",
			payload: payload
		}
	},
	updateSupportMail: (payload) => {
		return {
			type: "GENERAL/UPDATE_SUPPORT_MAIL",
			payload: payload
		}
	},
	saveIsEmailOptOut: (payload) => {
		return {
			type: "GENERAL/SAVE_IS_EMAIL_OPT_OUT",
			payload: payload
		}
	},
	saveIsRecipientTinUnMask: (payload) => {
		return {
			type: "GENERAL/SAVE_IS_RECIPIENT_TIN_UNMASK",
			payload: payload
		}
	},
	saveIsFormsRoutingToUSPSMail: (payload) => {
		return {
			type: "GENERAL/SAVE_IS_FORMS_ROUTING_TO_USPSMAIL",
			payload: payload
		}
	},
	getSalesTaxExemptionStatus: (payload) => {
		return {
			type: "GENERAL/GET_SALESTAX_EXEMPTION_STATUS",
			payload: payload
		}
	},
}

function* getGeneralSettingsAsync(action) {
	try {
		yield put(setLoadingState({ state: PAGE_STATE.LOADING, message: "Getting Settings......" }));
		const response = yield GeneralDataService.getGeneralSetting();
		if (response?.data?.Status === 0) {
			yield put(addNotifications({
				heading: "Error",
				message: response.data.Message,
				variant: TOASTER_VARIANT.DANGER
			}));
		}
		else {
			yield put(setFields(response.data.Data))
		}
	} catch (error) {
		yield put(addNotifications({
			heading: "Error",
			message: error?.response?.data?.Message,
			variant: TOASTER_VARIANT.DANGER
		}));
	} finally {
		yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
	}
}

function* updateMaskUnmaskOptionsAsync(action) {
	try {
		yield put(setLoadingState({ state: PAGE_STATE.LOADING, message: "Update Options......" }));
		const response = yield GeneralDataService.saveMaskAndUnMask(action.payload);
		if (response.data.Status === 0) {
			yield put(addNotifications({
				heading: "Error",
				message: response.data.Message,
				variant: TOASTER_VARIANT.DANGER
			}));
		}
		else {
			let isTinUnmaskAllowed =  typeof action?.payload?.ISUnmask === 'boolean' ? action?.payload?.ISUnmask : action?.payload?.ISUnmask === 'true';

			yield put (setIsTinUnmaskAllowed(isTinUnmaskAllowed))
			yield put(addNotifications({
				heading: "Success",
				message: response.data.Message,
				variant: TOASTER_VARIANT.SUCCESS
			}));
			yield call(getGeneralSettingsAsync)
			yield put(getUpdatedSignedInUserProfile())
		}
	} catch (error) {
		yield put(addNotifications({
			heading: "Error",
			message: error?.response?.data?.Message,
			variant: TOASTER_VARIANT.DANGER
		}));
	} finally {
		yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
	}
}

function* updateGeneralInfoAsync(action) {
	try {
		yield put(setLoadingState({ state: PAGE_STATE.LOADING, message: "Update Options......" }));
		const response = yield GeneralDataService.saveGeneralInfo(action.payload);
		if (response.data.Status === 0) {
			yield put(addNotifications({
				heading: "Error",
				message: response.data.Message,
				variant: TOASTER_VARIANT.DANGER
			}));
		}
		else {
			yield put(addNotifications({
				heading: "Success",
				message: response.data.Message,
				variant: TOASTER_VARIANT.SUCCESS
			}));
			yield call(getGeneralSettingsAsync)
			yield put(getUpdatedSignedInUserProfile())
		}
	} catch (error) {
		yield put(addNotifications({
			heading: "Error",
			message: error?.response?.data?.Message,
			variant: TOASTER_VARIANT.DANGER
		}));
	} finally {
		yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
	}
}

function* updateScheduleDateAsync(action) {
	try {
		yield put(setLoadingState({ state: PAGE_STATE.LOADING, message: "Update Options......" }));
		const response = yield GeneralDataService.saveScheduleDate(action.payload);
		if (response.data.Status === 0) {
			yield put(addNotifications({
				heading: "Error",
				message: response.data.Message,
				variant: TOASTER_VARIANT.DANGER
			}));
		}
		else {
			yield put(addNotifications({
				heading: "Success",
				message: response.data.Message,
				variant: TOASTER_VARIANT.SUCCESS
			}));
			yield call(getGeneralSettingsAsync)
			yield put(getUpdatedSignedInUserProfile())
		}
	} catch (error) {
		yield put(addNotifications({
			heading: "Error",
			message: error?.response?.data?.Message,
			variant: TOASTER_VARIANT.DANGER
		}));
	} finally {
		yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
	}
}

function* updateSupportMailAsync(action) {
	try {
		yield put(setLoadingState({ state: PAGE_STATE.LOADING, message: "Update Options......" }));
		const response = yield GeneralDataService.saveSupportMail(action.payload);
		if (response.data.Status === 0) {
			yield put(addNotifications({
				heading: "Error",
				message: response.data.Message,
				variant: TOASTER_VARIANT.DANGER
			}));
		}
		else {
			yield put(addNotifications({
				heading: "Success",
				message: response.data.Message,
				variant: TOASTER_VARIANT.SUCCESS
			}));
			yield call(getGeneralSettingsAsync)
			yield put(getUpdatedSignedInUserProfile())
		}
	} catch (error) {
		yield put(addNotifications({
			heading: "Error",
			message: error?.response?.data?.Message,
			variant: TOASTER_VARIANT.DANGER
		}));
	} finally {
		yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
	}
}

function* saveIsEmailOptOutAsync(action) {
	try {
		yield put(setLoadingState({ state: PAGE_STATE.LOADING, message: "Update Options......" }));
		const response = yield GeneralDataService.saveIsEmailOptOut(action.payload);
		if (response.data.Status === 0) {
			yield put(addNotifications({
				heading: "Error",
				message: response.data.Message,
				variant: TOASTER_VARIANT.DANGER
			}));
		}
		else {
			yield put(addNotifications({
				heading: "Success",
				message: response.data.Message,
				variant: TOASTER_VARIANT.SUCCESS
			}));
			yield call(getGeneralSettingsAsync)
			yield put(getUpdatedSignedInUserProfile())
		}
	} catch (error) {
		yield put(addNotifications({
			heading: "Error",
			message: error?.response?.data?.Message,
			variant: TOASTER_VARIANT.DANGER
		}));
	} finally {
		yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
	}
}

function* saveIsRecipientTinUnMaskAsync(action) {
	try {
		yield put(setLoadingState({ state: PAGE_STATE.LOADING, message: "Update Options......" }));
		const response = yield GeneralDataService.saveIsRecipientTinUnMask(action.payload);
		if (response.data.Status === 0) {
			yield put(addNotifications({
				heading: "Error",
				message: response.data.Message,
				variant: TOASTER_VARIANT.DANGER
			}));
		}
		else {
			yield put(addNotifications({
				heading: "Success",
				message: response.data.Message,
				variant: TOASTER_VARIANT.SUCCESS
			}));
			yield call(getGeneralSettingsAsync)
			yield put(getUpdatedSignedInUserProfile())
		}
	} catch (error) {
		yield put(addNotifications({
			heading: "Error",
			message: error?.response?.data?.Message,
			variant: TOASTER_VARIANT.DANGER
		}));
	} finally {
		yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
	}
}

function* saveIsFormsRoutingToUSPSMailAsync(action) {
	try {
		yield put(setLoadingState({ state: PAGE_STATE.LOADING }));
		const response = yield GeneralDataService.saveIsFormsRoutingToUSPSMail(action.payload);
		if (response?.data?.Status === 0) {
			yield put(addNotifications({
				heading: "Error",
				message: response.data.Message,
				variant: TOASTER_VARIANT.DANGER
			}));
		}
		else {
			yield put(addNotifications({
				heading: "Success",
				message: response.data.Message,
				variant: TOASTER_VARIANT.SUCCESS
			}));
			yield call(getGeneralSettingsAsync)
			yield put(getUpdatedSignedInUserProfile())
		}
	} catch (error) {
		yield put(addNotifications({
			heading: "Error",
			message: error?.response?.data?.Message,
			variant: TOASTER_VARIANT.DANGER
		}));
	} finally {
		yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
	}
}

function* getSalesTaxExmeptionStatusAsync() {
	try {
		yield put(setLoadingState({ state: PAGE_STATE.LOADING }));
		const response = yield GeneralDataService.getSalesTaxAdminStatus();
		
		if (response?.data?.Status === 0) {
			yield put(addNotifications({
				heading: "Error",
				message: response.data.Message,
				variant: TOASTER_VARIANT.DANGER
			}));
		}
		else {
			if(response?.data?.Status === 1 && response?.data?.Data){
				yield put(setSalesTaxAdminStatus(response?.data?.Data));
			}
			else{
				yield put(addNotifications({
					heading: "Error",
					message: 'Failed to get salesTax exemption status,please try after some time',
					variant: TOASTER_VARIANT.DANGER
				}));
			}
		}
	} catch (error) {
		yield put(addNotifications({
			heading: "Error",
			message: GENERIC_ERROR_MESSAGE,
			variant: TOASTER_VARIANT.DANGER
		}));
	} finally {
		yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
	}
}


function* rootSaga() {
	yield all([
		takeLatest(getGeneralSettings().type, getGeneralSettingsAsync),
		takeLatest(updateMaskUnmaskOptions().type, updateMaskUnmaskOptionsAsync),
		takeLatest(updateGeneralInfo().type, updateGeneralInfoAsync),
		takeLatest(updateScheduleDate().type, updateScheduleDateAsync),
		takeLatest(updateSupportMail().type, updateSupportMailAsync),
		takeLatest(saveIsEmailOptOut().type, saveIsEmailOptOutAsync),
		takeLatest(saveIsRecipientTinUnMask().type, saveIsRecipientTinUnMaskAsync),
		takeLatest(saveIsFormsRoutingToUSPSMail().type, saveIsFormsRoutingToUSPSMailAsync),
		takeLatest(getSalesTaxExemptionStatus().type, getSalesTaxExmeptionStatusAsync),
	]);
}
store.sagaManager.addSaga(componentKey, rootSaga);